module.exports = __webpack_public_path__ + "static/img/store.641b377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/store.png
// module id = D3rF
// module chunks = 58